<template>
  <div class="title-line">
    <div class="title-content">
      <i class="title-icon" :class="icon" />
      <span class="title"> {{ pageName }} </span>
    </div>
    <div class="tabs" v-if="showTabs">
      <span
        v-for="item in subModules"
        :key="item.code"
        class="tab-span"
        :class="{'active-tab': currentModule === item.code}"
        @click="changeModule(item.code)"
      >{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PageTitle',
  props: {
    icon: String,
    pageName: String,
    showTabs: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentModule: '',
      moduleMap: {
        // key为route.name
        // 构件列表
        ComponentList: [
          { code: 'V_Component_NOVA_DESIGN', name: '数维设计' },
          { code: 'V_Component_REVIT', name: 'Revit' },
        ],
        // 模块列表
        ModuleList: [
          { code: 'V_Module_NOVA_DESIGN', name: '数维设计' }
        ],
        // 模板列表
        SchemeList: [
          { code: 'V_Scheme_NOVA_DESIGN', name: '数维设计' }
        ]
      },
      subModules: [],
    }
  },
  computed: {
    ...mapGetters({
      clientTypeSoftwareCode: 'softwareCode',
      clientTypeSoftwareVersion: 'softwareVersion',
      clientType: 'platform'
    }),
  },

  mounted() {
    if (this.showTabs) {
      const mapKey = this.$route.name
      this.subModules = this.moduleMap[mapKey]
      const defaultTab = this.clientType === 'r' && ['ComponentList'].includes(mapKey) ? this.subModules[1] : this.subModules[0]
      this.changeModule(defaultTab?.code)
    }
  },
  methods: {
    changeModule(moduleCode) {
      this.currentModule = moduleCode
      this.$emit('module-change', moduleCode)
    },
  }
}
</script>

<style lang="less" scoped>
.title-line{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 12px 0;
  .title-content{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 0 16px;
  }
  .title-icon{
    margin-right: 8px;
    font-size: 24px;
  }
  .title{
    font-size: 20px;
  }
  .tab-span{
    display: inline-block;
    padding: 4px 10px;
    background: @bg-grey-normal;
    border-radius: 20px;
    cursor: pointer;
    &:hover{
      background: @theme-color-hover;
    }
    &.active-tab{
      background: @theme-color-hover;
      color: @theme-color;
    }
    &+.tab-span{
      margin-left: 10px;
    }
  }
}
</style>
